import React from "react";
import LeftSideFilterListItem from "./LeftSideFilterListItem";
import { Link, useNavigate } from "react-router-dom";
import { MdFilterList, MdFilterListOff } from "react-icons/md";
import { delayNavigation } from "../../helpers/helpers";
import { useDispatch } from "react-redux";

const FilterBurgerMenu = ({
  selectedProject,
  fillters,
  setFillters,
  burgerMenuIsOpen,
  setBurgerMenuIsOpen,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="flex row-start-3 col-span-full xl:col-span-4 xl:col-start-1 xl:pt-8 xl:pr-8 xl:hidden flex-col gap-6 justify-start items-start">
      <img
        src={selectedProject.listImg}
        alt="K2 Invest Green Home"
        className="w-full h-full object-cover object-center"
      />
      <ul className=" text-primary-bg-blue w-full ">
        <li
          className={`text-xl xl:text-4xl font-semibold tracking-wider ${
            burgerMenuIsOpen
              ? "border-b-2 border-b-primary-dark/30 border-opacity-30"
              : ""
          } pb-8 flex items-center justify-start gap-4`}
          onClick={() => setBurgerMenuIsOpen((prev) => !prev)}
        >
          {burgerMenuIsOpen ? (
            <MdFilterListOff className="text-2xl transition-all animate-fadeIn duration-75" />
          ) : (
            <MdFilterList className="text-2xl transition-all animate-fadeIn duration-75" />
          )}
          ფილტრები
        </li>
        {burgerMenuIsOpen && (
          <div className="transition-all animate-slideInTop duration-75">
            <LeftSideFilterListItem
              label={"საძინებლის რაოდენობა"}
              fillters={fillters}
              setFillters={setFillters}
              selectedProject={selectedProject}
            />
            <LeftSideFilterListItem
              label={"სართული"}
              fillters={fillters}
              setFillters={setFillters}
              selectedProject={selectedProject}
            />
            <LeftSideFilterListItem
              label={"ფართის მიხედვით"}
              fillters={fillters}
              setFillters={setFillters}
              selectedProject={selectedProject}
            />
          </div>
        )}
      </ul>
      <p
        className="hidden xl:block w-full relative group cursor-pointer text-xl font-bold tracking-wider text-primary-bg-blue border-b-2 border-b-primary-dark/30 border-opacity-30 py-8"
        onClick={() =>
          setFillters({
            floors: [],
            types: [],
            sizes: [],
          })
        }
      >
        ფილტრის გასუფთავება
        <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 group-hover:w-full"></span>
      </p>
      <Link
        className="hidden xl:block w-full relative group text-xl font-bold tracking-wider text-primary-bg-blue py-8"
        onClick={(event) => {
          delayNavigation(
            dispatch,
            navigate,
            `/projects/${selectedProject.name}/block`,
            event
          );
        }}
      >
        ვიზუალური სელექცია
        <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 group-hover:w-full"></span>
      </Link>
    </div>
  );
};

export default FilterBurgerMenu;
